// extracted by mini-css-extract-plugin
module.exports = {"donorparent":"ShareStory_donorparent__21PVA","container":"ShareStory_container__31kSE","contact":"ShareStory_contact__2Xhbn","image":"ShareStory_image__UXG8x"};